var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 2.99998C18.3327 2.08331 17.5827 1.33331 16.666 1.33331H3.33268C2.41602 1.33331 1.66602 2.08331 1.66602 2.99998M18.3327 2.99998V13C18.3327 13.9166 17.5827 14.6666 16.666 14.6666H3.33268C2.41602 14.6666 1.66602 13.9166 1.66602 13V2.99998M18.3327 2.99998L9.99935 8.83331L1.66602 2.99998",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/IconEmail.9357d4694c45ba53f61feef8e3328ac0.svg";
export { ForwardRef as ReactComponent };